import { render, staticRenderFns } from "./input-file.vue?vue&type=template&id=f51962da&scoped=true"
import script from "./input-file.ts?vue&type=script&lang=ts&external"
export * from "./input-file.ts?vue&type=script&lang=ts&external"
import style0 from "./input-file.vue?vue&type=style&index=0&id=f51962da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51962da",
  null
  
)

export default component.exports